/**
 *
 * @param {number} number
 * @returns Formatted number I.e. 1,2
 */
export const renderNumberFormat = (number, decimal = 0) => {
	if (!number && number < 0) {
		return "-";
	}
	var parts = Number(number).toFixed(decimal).toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

	return parts.join(",");
};

export const renderNumberFormatWithNegative = (number, decimal = 0) => {
	var parts = Number(number).toFixed(decimal).toString().split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");

	return parts.join(",");
};

export const renderNumberFormatCurrencyEuro = (number, decimal = 0) => {
	if (!number && number < 0) {
		return "-";
	}

	return (
		<div className="d-flex align-items-center">
			{renderNumberFormat(number, decimal)}{" "}
			<span className="pl-6 color-n300"> €</span>
		</div>
	);
};

export const squareAppend = () => {
	return (
		<>
			&nbsp;
			<div className="color-n300">
				m<sup>2</sup>
			</div>
		</>
	);
};

export const renderPackagePrice = (price = null) => {
	return (
		<>
			{!!price ? (
				renderNumberFormat(price, 2)
			) : (
				<span className="loading-icon"></span>
			)}{" "}
			&nbsp; €/m<sup>2</sup>
		</>
	);
};
